// extracted by mini-css-extract-plugin
module.exports = {"title":"commented_decision-module__title--2LViR","link":"commented_decision-module__link--zJa_W"};